<div [formGroup]="docForm">
  <div class="grid" style="margin-top: 20px;">
    <div class="col-1 documento-icon"><i class="fas fa-fw fa-map-marker-alt" title="posizione"></i></div>
    @if (posizione) {
    @for (level of hierarchy; track level; let i = $index) {
    @if (i === hierarchyDescriptionIndex) {
    <div class="col-11" [class.p-offset-1]="i > 0">
      <div class="documento-value">{{posizione[i] | fascicoloLabel}}</div>
      <label class="small-label">{{level}}</label>
    </div>
    <div class="col-1">
    </div>
    }
    @else {
    <div [class.col-4]="i % 3 !== 0" [class.col-3]="i % 3 === 0">
      <div class="documento-value">{{posizione[i] | fascicoloLabel}}</div>
      <label class="small-label">{{level}}</label>
    </div>
    }
    }
    <div class="col"></div>
    @if (hierarchy.length < posizione.length) { <div class="col-11 p-offset-1">
      @for (p of posizione | slice: hierarchy.length; track p?.posizioneId) {
      <span class="documento-value" style="display:inline;">[{{p | fascicoloLabel}}] </span>
      }
      <label class="small-label">Gerarchia fascicoli completa</label>
  </div>
  }
  }
</div>
<hr>
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon"><i class="fas fa-fw fa-tag" title="dati documento"></i></div>
  <div class="col-6">
    <span class="documento-value">{{documento.oggetto}}</span>
    <label class="small-label" for="oggetto">Oggetto</label>
    <div class="documento-edit">
      <input pInputText type="text" formControlName="oggetto" id="oggetto" [pTooltip]="getToolip('oggetto')"
        tooltipPosition="left" />
    </div>
  </div>
  <div class="col-2">
    <span class="documento-value">{{documento.lingua}}</span>
    <label class="small-label">Lingua</label>
    <div class="documento-edit">
      <p-dropdown formControlName="lingua" [options]="lingue" [editable]="true" [pTooltip]="getToolip('lingua')"
        tooltipPosition="left"></p-dropdown>
    </div>
  </div>
  <div class="col-2">
    <span class="documento-value">{{documento.dataDocumento | date: 'dd/MM/yyyy'}}</span>
    <label class="small-label">Data Documento</label>
    <div class="documento-edit">
      <p-calendar dateFormat="dd/mm/yy" [selectOtherMonths]="true" [showIcon]="true" formControlName="dataDocumento"
        [pTooltip]="getToolip('dataDocumento')" tooltipPosition="left">
      </p-calendar>
      <button pButton type="button" label="Oggi" title="Oggi" (click)="setToday()" class="p-button-secondary"></button>
    </div>
  </div>
</div>
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon"></div>
  <div class="col-2">
    <span class="documento-value">{{documento.versione}}</span>
    <label class="small-label">Versione</label>
  </div>
  <div class="col"></div>
</div>
<hr>
<div class="grid" [class.edit]="edit && (newDocument || trasmissioneRiproduzione)">
  <div class="col-1 documento-icon"><i class="fas fa-fw fa-shield-alt" title="sezione"></i></div>
  <div [ngClass]="isSegreto() || isOriginaleSegreto() ? 'col-2' : 'col-4'">
    <span class="documento-value" [appAnagraficaView]="AnagraficaQualificheService"
      [anagraficaId]="documento.qualificaId"></span>
    <label class="small-label">Qualifica</label>
    <div class="documento-edit">
      <p-autoComplete [appAnagraficaAutocomplete]="AnagraficaQualificheService" #qualificaInput
        [filterCollection]="filterQualifica" formControlName="qualifica" [pTooltip]="getToolip('qualifica')"
        tooltipPosition="left" (ngModelChange)="setSezioneId()">
      </p-autoComplete>
    </div>
  </div>
  <div [ngClass]="isSegreto() || isOriginaleSegreto() ? 'col-2' : 'col-3'">
    <span class="documento-value" [appAnagraficaView]="AnagraficaClassificheService" [qualifica]="qualificaInput.value"
      [anagraficaId]="documento.classificaId"></span>
    <label class="small-label">Classifica</label>
    <div class="documento-edit">
      <p-autoComplete [appAnagraficaAutocomplete]="AnagraficaClassificheService" [qualifica]="qualificaInput.value"
        formControlName="classifica" [pTooltip]="getToolip('classifica')" tooltipPosition="left" #classificaInput
        (ngModelChange)="classificaChanged()">
      </p-autoComplete>
    </div>
    @if (newDocument) {
    <div class="field-checkbox">
      <label class="small-label" for="esercitazione">Esercitazione</label>
      <p-checkbox [binary]="true" formControlName="esercitazione" inputId="esercitazione"
        (ngModelChange)="setSezioneId()">
      </p-checkbox>
    </div>
    }
  </div>
  @if (isSegreto() || isOriginaleSegreto()) {
  <div class="col-2">
    @if (isSegreto() && newDocument && !documento.arrivo) {
    <label class="small-label" for="noCarico">Da declassificare <i class="fas fa-circle-question"
        title="Non genera i numeri di carico e controllo"></i></label>
    <p-checkbox [binary]="true" formControlName="noCarico" inputId="noCarico">
    </p-checkbox>
    }
    @else {
    <div class="placeholder" style="height: 38px;"></div>
    }
    @if ( isOriginaleSegreto() && newDocument && !documento.arrivo) {
    <!-- New checkbox for "Scarica allegati dal carico <xxx>" -->
    <label class="small-label" for="scaricaAllegati">Scarica allegati dal carico {{documento.numeroCarico}}</label>
    <p-checkbox [binary]="true" formControlName="scaricaAllegati" inputId="scaricaAllegati">
    </p-checkbox>
    }
  </div>
  <div class="col-3">
    <span class="documento-value">{{documento.ambito || '&nbsp;' }}</span>
    <label class="small-label" for="ambito">Ambito di circolazione</label>
    <div class="documento-edit">
      <input pInputText type="text" formControlName="ambito" id="ambito" [pTooltip]="getToolip('ambito')"
        tooltipPosition="left" maxlength="50" />
    </div>
  </div>
  }
  <div [hidden]="!useSections()" [ngClass]="isSegreto() || isOriginaleSegreto() ? 'col-2' : 'col-4'">
    <span class="documento-value">{{getSezione()}}</span>
    <label class="small-label pl-2">Sezione</label>
    <span class="documento-edit">{{getSezione()}}</span>
  </div>
</div>
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon"></div>
  <div class="col-5">
    <span class="documento-value">{{getCaveatDiSicurezzaDisplay()}}</span>
    <label class="small-label" for="caveatDiSicurezzaId">Caveat di sicurezza</label>
    <div class="documento-edit">
      <p-dropdown formControlName="caveatDiSicurezzaId" [options]="caveatDiSicurezza" placeholder="Seleziona"
        [pTooltip]="getToolip('caveatDiSicurezzaId')" tooltipPosition="left" styleClass="w-full"></p-dropdown>
    </div>
  </div>
  <div class="col-5">
    <span class="documento-value">
      @if ((documento.caveatDiSicurezzaId === 4) && documento.caveatDiSicurezzaAltro) {
        {{documento.caveatDiSicurezzaAltro}}
      }
    </span>
    @if (docForm.controls.caveatDiSicurezzaId.value === 4) {
    <label class="small-label" for="caveatDiSicurezzaAltro">Altro</label>
    <div class="documento-edit">
      <input pInputText type="text" id="caveatDiSicurezzaAltro" formControlName="caveatDiSicurezzaAltro"
        [pTooltip]="getToolip('caveatDiSicurezzaAltro')" tooltipPosition="left" maxlength="255" />
    </div>
    }
  </div>
  <div class="col"></div>
</div>
@if (shouldShowOrganiSicurezza()) {
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon"><i class="fas fa-fw fa-user-shield" title="organi di sicurezza"></i></div>
  <div class="col-5">
    <span class="documento-value">{{documento.organoSicurezzaOriginatore}}</span>
    <label class="small-label" for="organoSicurezzaOriginatore">Organo di sicurezza originatore</label>
    <div class="documento-edit">
      <p-dropdown formControlName="organoSicurezzaOriginatore" [options]="soggetti" optionLabel="nomeIndirizzo"
        optionValue="nomeIndirizzo" inputId="organoSicurezzaOriginatore" placeholder="Seleziona" [filter]="true"
        filterBy="nomeIndirizzo" [showClear]="true" [pTooltip]="getToolip('organoSicurezzaOriginatore')"
        tooltipPosition="left" styleClass="w-full"></p-dropdown>
    </div>
  </div>
  <div class="col-5">
    <span class="documento-value">{{documento.organoSicurezzaDestinatario}}</span>
    <label class="small-label" for="organoSicurezzaDestinatario">Organo di sicurezza destinatario</label>
    <div class="documento-edit">
      <p-dropdown formControlName="organoSicurezzaDestinatario" [options]="soggetti" optionLabel="nomeIndirizzo"
        optionValue="nomeIndirizzo" inputId="organoSicurezzaDestinatario" placeholder="Seleziona" [filter]="true"
        filterBy="nomeIndirizzo" [showClear]="true" [pTooltip]="getToolip('organoSicurezzaDestinatario')"
        tooltipPosition="left" styleClass="w-full"></p-dropdown>
    </div>
  </div>
  <div class="col"></div>
</div>
<hr>
}
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon"><i class="fas fa-fw fa-scroll" title="documento analogico"></i></div>
  <div class="col-11">
    <div class="riservato-field documento-analogico-field">
      <span class="documento-value">Documento analogico: {{ documento.documentoAnalogico ? 'Sì' : 'No' }}</span>
      <div class="documento-edit">
        <div class="field-checkbox">
          <label class="small-label ml-0" for="documentoAnalogico">Documento analogico</label>
          <p-inputSwitch formControlName="documentoAnalogico" inputId="documentoAnalogico" class="ml-2"
            ariaLabel="Documento analogico"></p-inputSwitch>
        </div>
      </div>
    </div>
  </div>
</div>
@if (!docForm.controls.documentoAnalogico.value) {
<div class="grid" [class.edit]="edit">
    <div class="col-1 documento-icon"></div>
    <div class="col-11">
      <span class="documento-value">{{ getModalitaFormazioneLabel(documento.modalitaFormazioneId) }}</span>
      <label class="small-label">Modalità di formazione</label>
      <div class="documento-edit full-width">
        <p-dropdown formControlName="modalitaFormazioneId" [options]="modalitaFormazione" [editable]="true"
          [showClear]="true" [pTooltip]="getToolip('modalitaFormazioneId')" tooltipPosition="left"
          styleClass="w-full" panelStyleClass="modalita-formazione-panel"></p-dropdown>
      </div>
    </div>
  </div>
  <div class="grid" [class.edit]="edit">
    <div class="col-1 documento-icon"></div>
    <div class="col-11">
      <span class="documento-value">{{ getProdottoSoftwareLabel(documento.prodottoSoftwareId) }}</span>
      <label class="small-label">Prodotto Software</label>
      <div class="documento-edit full-width">
        <p-dropdown formControlName="prodottoSoftwareId" [options]="prodottiSoftware" [showClear]="true"
          [pTooltip]="getToolip('prodottoSoftwareId')" tooltipPosition="left" styleClass="w-full"></p-dropdown>
      </div>
    </div>
  </div>
}

  <div class="grid" [class.edit]="edit">
    <div class="col-1 documento-icon"></div>
  <div class="col-5">
    <span class="documento-value">{{ getTipoDocumentoLabel(documento.tipoDocumentoId) }}</span>
    <label class="small-label">Tipo di documento</label>
    <div class="documento-edit">
      <p-dropdown formControlName="tipoDocumentoId" [options]="tipiDocumento" [editable]="true" [showClear]="true"
        [pTooltip]="getToolip('tipoDocumentoId')" tooltipPosition="left"></p-dropdown>
    </div>
  </div>
  <div class="col-6">
    <span class="documento-value">{{ getAmbitoUtilizzoLabel(documento.ambitoUtilizzoId) }}</span>
    <label class="small-label">Ambito di utilizzo del documento</label>
    <div class="documento-edit">
      <p-dropdown formControlName="ambitoUtilizzoId" [options]="ambitiUtilizzo" [editable]="true" [showClear]="true"
        [pTooltip]="getToolip('ambitoUtilizzoId')" tooltipPosition="left"></p-dropdown>
    </div>
  </div>
</div>
@if (docForm.controls.documentoAnalogico.value) {
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon"><i class="fas fa-fw fa-copy" title="numero pagine"></i></div>
  <div class="col-5">
    <span class="documento-value">{{documento.numeroPagine}}</span>
    <label class="small-label" for="numeroPagine">Numero delle pagine</label>
    <div class="documento-edit">
      <input pInputText type="number" formControlName="numeroPagine" id="numeroPagine"
        [pTooltip]="getToolip('numeroPagine')" tooltipPosition="left" min="1" />
    </div>
  </div>
  <div class="col"></div>
</div>
}
<hr>
@if (documento.arrivo) {
<!-- SEZIONE DOCUMENTO IN ARRIVO-->
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon"></div>
  <div class="col-4">
    <span class="documento-value" [appAnagraficaView]="AnagraficaIndirizziService"
      [anagraficaId]="documento.mittenteId"></span>
    <label class="small-label">Mittente</label>
    <div class="documento-edit">
      <app-dati-documento-mittente formControlName="mittente" [showNuovoSoggettoButton]="newDocument"
        (openNuovoSoggettoDialog)="openSoggettoDialog()"
        [pTooltip]="getToolip('mittente')" tooltipPosition="left">
      </app-dati-documento-mittente>
    </div>
  </div>
  <div class="col-3">
    @if (isSegreto()) {
    <span class="documento-value">{{documento.numeroControllo}}</span>
    <label class="small-label" for="numeroControllo">Numero di Controllo</label>
    <div class="documento-edit">
      <input pInputText type="text" formControlName="numeroControllo" id="numeroControllo"
        [pTooltip]="getToolip('numeroControllo')" tooltipPosition="left" />
    </div>
    }
  </div>
  <div class="col-2">
    <span class="documento-value">{{documento.protocolloMittente}}</span>
    <label class="small-label" for="protocolloMittente">Protocollo mittente</label>
    <div class="documento-edit">
      <input pInputText type="text" formControlName="protocolloMittente" id="protocolloMittente"
        [pTooltip]="getToolip('protocolloMittente')" tooltipPosition="left" />
    </div>
  </div>
</div>
}

@if (documento.arrivo && isSegreto()) {
<!-- SEZIONE CARICO DOCUMENTO IN ARRIVO-->
<hr>
<div class="grid" [class.edit]="edit" formGroupName="caricoArrivo">
  <div class="col-1 documento-icon"><i class="fas fa-fw fa-download" title="registro di carico"></i></div>
  <div class="col-5">
    <span class="documento-value">{{documento.numeroEsemplariRicevuti}}</span>
    <label class="small-label" for="numeroEsemplariRicevuti">Numero di Esemplari Ricevuti</label>
    <div class="documento-edit">
      <input pInputText type="number" formControlName="numeroEsemplariRicevuti" id="numeroEsemplariRicevuti"
        [pTooltip]="getToolip('numeroEsemplariRicevuti')" tooltipPosition="left" />
    </div>
  </div>
  <div class="col-6">
    <span class="documento-value">{{documento.numeroDistintoCopie}}</span>
    <label class="small-label" for="numeroDistintoCopie">Numero distinto delle copie</label>
    <div class="documento-edit">
      <input pInputText type="number" formControlName="numeroDistintoCopie" id="numeroDistintoCopie"
        [pTooltip]="getToolip('numeroDistintoCopie')" tooltipPosition="left" />
    </div>
  </div>
  <div class="col-1 "></div>
  <div class="col-5">
    <span class="documento-value">{{documento.numeroAllegati}}</span>
    <label class="small-label" for="allegatiRicevuti">Allegati Ricevuti</label>
    <div class="documento-edit">
      <textarea pInputTextarea formControlName="allegatiRicevuti" [rows]="3" [cols]="20" [autoResize]="true"
        title="Allegati Ricevuti" [pTooltip]="getToolip('allegatiRicevuti')" tooltipPosition="left" maxlength="3000"
        class="allegati-ricevuti-textarea"></textarea>
    </div>
  </div>
  <div class="col-6">
    <span class="documento-value">{{documento.copieInCarico}}</span>
    <label class="small-label" for="copieInCarico">Copie in carico</label>
    <div class="documento-edit">
      <input pInputText type="text" formControlName="copieInCarico" id="copieInCarico"
        [pTooltip]="getToolip('copieInCarico')" tooltipPosition="left" />
    </div>
  </div>
</div>
<!--    FINE SEZIONE          -->
}

@if (!documento.arrivo) {
<!-- SEZIONE DOCUMENTO IN PARTENZA  -->
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon"></div>
  <div class="col-4">
    <span class="documento-value" [appAnagraficaView]="AnagraficaIndirizziService"
      [anagraficaId]="documento.mittenteId"></span>
    <label class="small-label">Mittente</label>
    <div class="documento-edit">
      <app-dati-documento-mittente formControlName="mittente" [showNuovoSoggettoButton]="newDocument"
        (openNuovoSoggettoDialog)="openSoggettoDialog()"
        [pTooltip]="getToolip('mittente')" tooltipPosition="left">
      </app-dati-documento-mittente>
    </div>
  </div>
  <div class="col"></div>
</div>
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon">
    @if (documento.documentoDestinatario?.length === 1) {
    <i class="fas fa-fw fa-user"></i>
    }
    @else {
    <i class="fas fa-fw fa-users"></i>
    }
  </div>
  <div class="col-4">
    <div class="dest-container documento-value">
      @if (documento.documentoDestinatario && documento.documentoDestinatario.length === 1) {
      <span [appAnagraficaView]="AnagraficaIndirizziService"
        [anagraficaId]="documento.documentoDestinatario[0].destinatarioId"></span>
      }
      @else {
      <ul>
        @for (dest of documento.documentoDestinatario; track dest) {
        <li>
          <span [appAnagraficaView]="AnagraficaIndirizziService" [anagraficaId]="dest.destinatarioId"></span>
        </li>
        }
      </ul>
      }
    </div>
    <label class="small-label">Destinatari</label>
    <div class="documento-edit">
      <app-dati-documento-destinatari formControlName="destinatari" (addIndirizzo)="addIndirizzo($event)"
        [pTooltip]="getToolip('destinatari')" tooltipPosition="left">
      </app-dati-documento-destinatari>
    </div>
  </div>
  <div class="col-3">
    @if (showPrecedenza) {
    <span class="documento-value" [appAnagraficaView]="AnagraficaPrecedenzeService"
      [anagraficaId]="documento.precedenzaId"></span>
    <label class="small-label">Qualifica Precedenza</label>
    <div class="documento-edit">
      <p-autoComplete [appAnagraficaAutocomplete]="AnagraficaPrecedenzeService" formControlName="precedenzaId"
        [pTooltip]="getToolip('precedenzaId')" tooltipPosition="left">
      </p-autoComplete>
    </div>
    }
  </div>
  <div class="col-2">
    <span class="documento-value">{{documento.dataInvio | date: 'dd/MM/yyyy'}}</span>
    <label class="small-label">Data Invio</label>
    <div class="documento-edit">
      <p-calendar dateFormat="dd/mm/yy" [selectOtherMonths]="true" [showIcon]="true" formControlName="dataInvio"
        [pTooltip]="getToolip('dataInvio')" tooltipPosition="left">
      </p-calendar>
    </div>
  </div>
</div>
<!--    FINE SEZIONE          -->
}

@if (!documento.arrivo && isSegreto()) {
<!-- SEZIONE CARICO DOCUMENTO IN PARTENZA-->
<div class="grid" [class.edit]="edit" formGroupName="caricoPartenza">
  <div class="col-1 documento-icon"><i class="fas fa-fw fa-download" title="registro di carico"></i></div>
  <div class="col-5">
    <span class="documento-value">{{documento.numeroAllegati}}</span>
    <label class="small-label" for="allegatiOriginati">Allegati Originati</label>
    <div class="documento-edit">
      <input pInputText type="text" formControlName="allegatiOriginati" id="allegatiOriginati"
        [pTooltip]="getToolip('allegatiOriginati')" tooltipPosition="left" />
    </div>
  </div>
</div>
<!--    FINE SEZIONE          -->
}

@if (documento.documentoId && !trasmissioneRiproduzione) {
<hr>
<div class="grid">
  <div class="col-1 documento-icon"><i class="fas fa-fw fa-exchange-alt"></i></div>
  <div class="col-4">
    <span class="documento-value">
      <span [appAnagraficaView]="AnagraficaStatiService" [anagraficaId]="ultimoStato.toStato"></span>
      ({{ultimoStato.utente}})
    </span>
    <label class="small-label">Stato</label>
  </div>
  <div class="col-4">
    <span class="documento-value">
      <span>{{ultimoStato.timeStamp | dataStorico }}</span>
    </span>
    <label class="small-label">Dal</label>
  </div>
  <div class="col-3">
    @if ( documento.statoId === 2) {
    <span class="documento-value">{{documento.dataScadenza | date: 'dd/MM/yyyy'}}</span>
    <label class="small-label">Scadenza</label>
    }
  </div>
</div>
}

<!--<hr *ngIf="trasmissioneRiproduzione">
    <div class="grid" *ngIf="trasmissioneRiproduzione">
      <div class="col-1 documento-icon"><i class="fas fa-fw fa-registered"></i></div>
      <div class="col-3">
        <label for="numeroRichiesta" class="small-label">N° richiesta</label>
        <input id="numeroRichiesta" class="width-fill-available" pInputText type="text" formControlName="numeroRichiesta" required>
      </div>
      <div class="col-4">
        <label for="utente" class="small-label">Utente</label>
        <p-autoComplete inputId="utente" formControlName="richiedente" [suggestions]="utentiFiltrati" [style]="{'width':'100%'}"
          (completeMethod)="utentiFiltrati = autocompleteFilter($event, utenti, 'nomeUtente', true)" [dropdown]="true"
          [forceSelection]="true" [autoHighlight]="true"  appendTo="body">
        </p-autoComplete>
      </div>
      <div class="col-4">
        <label for="dataRichiesta" class="small-label">Data richiesta</label>
        <p-calendar id="dataRichiesta" [showIcon]="true" [style]="{'width':'100%'}"
          dateFormat="dd/mm/yy" [selectOtherMonths]="true" appendTo="body" formControlName="dataRichiesta">
        </p-calendar>
      </div>
    </div>-->

<hr>
<div class="grid" [class.edit]="edit">
  <div class="col-1 documento-icon" title="Contenuto"><i class="fas fa-fw fa-quote-right" title="note"></i></div>
  <div class="col-11">
    <span class="documento-value">{{documento.noteEtichetta}}</span>
    <label class="small-label" for="noteEtichetta">Etichetta</label>
    <div class="documento-edit">
      <input pInputText type="text" formControlName="noteEtichetta" id="noteEtichetta"
        [pTooltip]="getToolip('noteEtichetta')" tooltipPosition="left" maxlength="50" />
    </div>
    <span class="documento-value note">{{documento.note}}</span>
    <label class="small-label" for="note">Note</label>
    <div class="documento-edit">
      <textarea pInputTextarea formControlName="note" [rows]="10" [cols]="50" [autoResize]="true" title="Note"
        [pTooltip]="getToolip('note')" tooltipPosition="left" maxlength="3000"></textarea>
    </div>
    <span class="documento-value">{{documento.paroleChiave?.join(', ')}}</span>
    <label class="small-label" for="paroleChiave">Parole chiave</label>
    <div class="documento-edit">
      <p-chips formControlName="paroleChiave" inputId="paroleChiave" separator="," [addOnBlur]="true"
        [pTooltip]="getToolip('paroleChiave')" tooltipPosition="left">
      </p-chips>
    </div>
  </div>
</div>
</div>

<app-soggetto-dialog></app-soggetto-dialog>
